import { useEffect } from "react";
import { useMap } from "react-leaflet";

const ZoomTracker = ({ setScale }) => {
  const map = useMap();

  useEffect(() => {
    const handleZoom = () => {
      const zoom = map.getZoom();
      const scale = Math.pow(zoom / 6, 1.2);
      setScale(scale);
    };

    map.on("zoom", handleZoom);
    handleZoom();

    return () => map.off("zoom", handleZoom);
  }, [map, setScale]);

  return null;
};

export default ZoomTracker;